import { COMPANY } from './company'
import { ROUTES } from './routes'
import type { LocationRegion, OfferGroup } from './content-pages'

export const LOCATIONS_PAGE = {
  eyebrow: 'Service areas',
  title: 'Available locations',
  lead: `${COMPANY.brandName} provides premium flowers, plants, corporate gifting, plant rental, landscaping, and event decoration services across Delhi NCR and selected cities throughout India.`,
  serveTitle: 'We proudly serve',
  regions: [
    {
      name: 'Delhi NCR',
      cities: ['Noida', 'Greater Noida', 'Ghaziabad', 'Delhi', 'Gurugram (Gurgaon)', 'Faridabad'],
    },
    {
      name: 'Uttar Pradesh',
      cities: ['Lucknow', 'Kanpur', 'Agra', 'Varanasi', 'Prayagraj', 'Meerut'],
    },
    {
      name: 'Haryana',
      cities: ['Gurugram', 'Faridabad', 'Sonipat', 'Panipat', 'Karnal'],
    },
    {
      name: 'Rajasthan',
      cities: ['Jaipur', 'Udaipur', 'Jodhpur'],
    },
    {
      name: 'Punjab',
      cities: ['Chandigarh', 'Ludhiana', 'Amritsar'],
    },
    {
      name: 'Maharashtra',
      cities: ['Mumbai', 'Pune', 'Nagpur'],
    },
    {
      name: 'Karnataka',
      cities: ['Bengaluru', 'Mysuru'],
    },
    {
      name: 'Telangana',
      cities: ['Hyderabad'],
    },
    {
      name: 'Tamil Nadu',
      cities: ['Chennai', 'Coimbatore'],
    },
    {
      name: 'Gujarat',
      cities: ['Ahmedabad', 'Surat', 'Vadodara'],
    },
    {
      name: 'West Bengal',
      cities: ['Kolkata'],
    },
    {
      name: 'Madhya Pradesh',
      cities: ['Indore', 'Bhopal'],
    },
    {
      name: 'Odisha',
      cities: ['Bhubaneswar'],
    },
    {
      name: 'Bihar',
      cities: ['Patna'],
    },
    {
      name: 'Uttarakhand',
      cities: ['Dehradun'],
    },
  ] satisfies LocationRegion[],
  missingCity:
    "Don't see your city? Contact us — we are continuously expanding our network across India.",
  servicesTitle: 'Our services',
  services: [
    {
      title: 'Flower delivery',
      items: [
        'Fresh flower bouquets',
        'Luxury flower arrangements',
        'Flower baskets',
        'Flower boxes',
        'Wedding flowers',
        'Anniversary flowers',
        'Birthday flowers',
        'Sympathy flowers',
        'Congratulations bouquets',
      ],
    },
    {
      title: 'Plants & green solutions',
      items: [
        'Indoor plants',
        'Outdoor plants',
        'Air purifying plants',
        'Lucky plants',
        'Plant gifting',
        'Plant rental',
        'Plant maintenance',
        'Office greenery',
        'Landscaping services',
      ],
    },
    {
      title: 'Corporate gifting',
      items: [
        'Employee welcome kits',
        'Joining kits',
        'Festive gift hampers',
        'Diwali gifts',
        'Client gifts',
        'Employee appreciation gifts',
        'Promotional gifts',
        'Customized corporate gifts',
        'Bulk gifting solutions',
      ],
    },
    {
      title: 'Event & office decoration',
      items: [
        'Corporate event decoration',
        'Office decoration',
        'Festival decoration',
        'Independence Day decoration',
        'Republic Day decoration',
        'Diwali decoration',
        'Christmas decoration',
        'New Year decoration',
        'Sales gallery decoration',
        'Sample flat decoration',
        'Product launch events',
        'Inauguration ceremony decoration',
      ],
    },
    {
      title: 'Business solutions',
      items: [
        'Corporate flower subscription',
        'Reception floral arrangements',
        'Office plant rental',
        'Green workspace solutions',
        'AMC for plant maintenance',
        'Bulk floral decoration',
        'Customized branding & gifting',
      ],
    },
    {
      title: 'Special occasion services',
      items: [
        'Birthday celebrations',
        'Anniversaries',
        'Weddings',
        'Baby shower',
        'Housewarming',
        'Farewell parties',
        'Corporate events',
        'Award ceremonies',
        'Conferences & exhibitions',
      ],
    },
  ] satisfies OfferGroup[],
  whyTitle: 'Why choose Maaliondoor?',
  whyItems: [
    'Premium quality flowers & plants',
    'One-stop gifting solution',
    'Corporate & bulk order specialist',
    'Fast & reliable delivery',
    'Customized decoration services',
    'Sustainable & eco-friendly solutions',
    'Dedicated account management for corporate clients',
    'Serving Delhi NCR & expanding across India',
    'Trusted by leading businesses and individuals',
  ],
  ctaTitle: 'Need services in your city?',
  ctaTo: ROUTES.contact,
  ctaLabel: 'Contact us',
  tagline: 'Maaliondoor – Your trusted partner for flowers, plants & gifting solutions.',
} as const
